import { Link } from "@tanstack/react-router";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

export default function NavBar() {
  return (
    <NavigationMenu className="bg-white text-primary-foreground">
      <NavigationMenuList>
        <NavigationMenuItem>
          <Link to="/tutors">
            <NavigationMenuLink
              className={navigationMenuTriggerStyle({
                className: "bg-white text-black",
              })}
            >
              Tutors
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>

        {/* The Pipe Separator */}
        <NavigationMenuItem>
          <span className="text-black px-2">|</span>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link to="/classes/browse">
            <NavigationMenuLink
              className={navigationMenuTriggerStyle({
                className: "bg-white text-black",
              })}
            >
              Class Catalog
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
